/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { Log } from "../../logging";
import { ForgeCryptoProvider } from "./ForgeCryptoProvider";
import { CryptoProvider } from "./TCryptoProvider";
import { WebCryptoProvider } from "./WebCryptoProvider";

export class CryptoProviderFactory {
  private static readonly TAG: string = "CryptoProviderFactory";

  public static readonly RSA_ALGORITHM: string = "RSASSA-PKCS1-v1_5";

  public static readonly RS256_ALGORITHM: string = "RS256";

  public static readonly RS512_ALGORITHM: string = "RS512";

  public static readonly SHA256_ALGORITHM: string = "SHA-256";

  public static isWebCryptoAvailable(): boolean {
    return (
      typeof crypto !== "undefined" &&
      !!crypto.subtle &&
      typeof crypto.subtle.generateKey === "function" &&
      typeof crypto.subtle.importKey === "function" &&
      typeof crypto.subtle.sign === "function" &&
      typeof crypto.subtle.digest === "function"
    );
  }

  public static getProvider(): CryptoProvider {
    if (CryptoProviderFactory.isWebCryptoAvailable()) {
      Log.i(
        CryptoProviderFactory.TAG,
        "Web Crypto API available, using WebCryptoProvider"
      );
      return WebCryptoProvider;
    }

    Log.e(
      CryptoProviderFactory.TAG,
      "Web Crypto API not available, falling back to ForgeCryptoProvider"
    );
    return ForgeCryptoProvider;
  }

  public static arrayBufferToBase64(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);

    let binary = "";

    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return btoa(binary);
  }
}
